import React from 'react';

import { Field, FieldProps } from 'formik';

import Typography from 'antd/lib/typography';

import { FormikInput } from '@common/react/components/Forms/FormikInput/FormikInput';

import { PetPrice } from '@app/objects/PetPrice';
import { FormValues } from '@app/components/Pages/ClinicPetEditor/types';

import { NumberField } from '@app/components/UI/NumberField/NumberField';

interface SpecialServiceCountColumnProps {
	record: PetPrice;
}

function formatService(item: PetPrice, record: PetPrice, count: number): PetPrice {
	if (item.clientId !== record.clientId) return item;

	const batchCount: number = item.price?.batchCount ?? 0;
	const batchPrice: number = item.price?.batchPrice ?? 0;
	const perItem: number = item.price?.value ?? 0;

	const value = batchPrice + Math.max(count - batchCount, 0) * perItem;
	const extra = count <= batchCount ? 0 : (count - batchCount) * perItem;

	return {
		...item,
		count,
		value,
		extra,
	};
}

export const SpecialServiceCountColumn: React.FC<SpecialServiceCountColumnProps> = ({ record }: SpecialServiceCountColumnProps) => (
	<Field name="services">
		{(fieldProps: FieldProps<FormValues>) => (
			<FormikInput
				fieldProps={fieldProps}
				containerClassName=""
				render={({ field, form }: FieldProps<Array<PetPrice>, FormValues>) => {
					const isPreset = Boolean(record.parentId);

					if (isPreset) {
						return (
							<Typography.Text>
								{record.count}
							</Typography.Text>
						);
					}

					return (
						<NumberField
							{...field}
							min={0}
							style={{ textAlign: 'right' }}
							value={record.count}
							onChange={(count: number) => {
								const services = field.value.map((item: PetPrice) => formatService(item, record, count));
								form.setFieldValue(field.name as keyof FormValues, services, false);
							}}
						/>
					);
				}}
			/>
		)}
	</Field>
);
